module.exports = __webpack_public_path__ + "static/hero-f340e4e7daf569b56d1ab45538686b61.png";